const ApiUrl = "https://voetbalapi.gerbonno.nl/";
export const ImageUrl = "https://voetbalapi.gerbonno.nl/images/";

export default ApiUrl;